// Firebase codes are mapped, never shown verbatim: they distinguish "no such user" from
// "wrong password", which would disclose which staff emails exist. Shared by every screen
// that calls Firebase sign-up/sign-in directly (invite acceptance, self-serve sign-up) so
// there is exactly one place this collapsing happens, not two independently-drifting copies.
export function friendlyAuthError(e: unknown): string {
  const code = (e as { code?: string })?.code ?? "";
  if (code === "auth/email-already-in-use") return "That address already has an account — sign in instead.";
  if (code === "auth/weak-password") return "Use at least 6 characters.";
  if (code === "auth/too-many-requests") return "Too many attempts. Please wait a minute and try again.";
  if (code === "auth/invalid-email") return "That doesn't look like a valid email address.";
  // Only the codes Firebase actually uses for a rejected credential map to the credential
  // message, and they collapse into one: auth/user-not-found vs auth/wrong-password would
  // otherwise disclose which staff emails exist. Anything else — a dropped connection mid
  // sign-UP, an SDK misconfiguration — is not the user's password being wrong, and saying so
  // sends them off retyping a password that was fine.
  if (code === "auth/wrong-password" || code === "auth/user-not-found" ||
      code === "auth/invalid-credential" || code === "auth/invalid-login-credentials") {
    return "Wrong email or password.";
  }
  if (code === "auth/network-request-failed") return "No connection. Check your signal and try again.";
  return "Something went wrong. Please try again.";
}
